import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { serviceCode } from "../../../shared/service-code/service-code.const";
import { SelectItem } from "primeng/api";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { SelectedChipsComponent } from "../../chip/selected-chips.component";
import { Checkbox } from "primeng/checkbox";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-service-code-select",
  templateUrl: "./service-code-select.component.html",
  styleUrls: ["./service-code-select.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Checkbox, FormsModule, SelectedChipsComponent],
})
export class ServiceCodeSelectComponent implements OnInit {
  readonly appendTo = input("body");
  readonly disabled = input(false);
  readonly required = input(false);
  @Input() selectedServiceCodes: string[] = [];
  readonly selectionChange = output<string[]>();

  public serviceCodeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildTypeList();
  }

  onSelectionChange() {
    this.selectionChange.emit(this.selectedServiceCodes);
  }

  public readonly chipLabel = (code: string): string =>
    this.getServiceCodeLabel(code);

  public removeServiceCode(code: string) {
    this.selectedServiceCodes = (this.selectedServiceCodes ?? []).filter(
      (item) => item !== code,
    );
    this.onSelectionChange();
  }

  public isSelected(code: string): boolean {
    return (this.selectedServiceCodes ?? []).includes(code);
  }

  public getServiceCodeLabel(code: string): string {
    return (
      this.serviceCodeList.find((item) => item.value === code)?.label ?? ""
    );
  }

  private buildTypeList() {
    Object.keys(serviceCode).map((key) => {
      this.serviceCodeList.push({
        label: key,
        value: key,
      });
    });
  }
}
